import type { Locale as DateLocale } from 'date-fns'
import type { SRT_Localization } from '../components/master-table'

import { useTranslation } from 'react-i18next'

import i18n from './client'
import { dateLocales, masterTableLocales } from './lib-localizations'

export const useLocale = () => {
	const { i18n } = useTranslation()

	return i18n.language
}
export const getLangCode = (lang: string) => langCodeMapping[lang] || 'en-US'
export const getDatesLocale = (): DateLocale =>
	dateLocales[i18n.language] || dateLocales.en

export const getMasterTableLocale = (): SRT_Localization =>
	masterTableLocales[i18n.language] || masterTableLocales.en

export const langCodeMapping: Record<string, string> = {
	en: 'en-US',
	uk: 'uk-UA',
	de: 'de-DE',
	es: 'es-ES',
}
